import React from 'react';
import { connect } from 'react-redux'
import Picker from '../../../../components/picker/Picker'
import {clearIntervalGetToken} from '../../../../components/picker/Picker'
import Wix from 'Wix';
import UI from 'editor-ui-lib';
import setDataPublic from '../../../../../actions/dataPublicActions';
import { updateConnect } from '../../../../../actions/updateConnectActions';
import {onOpenModalPicker} from '../helperFunction';
import googledrive_logo from './googledrive_logo.png';
import axios from 'axios'
import httpRequest from "../../../../../widget/api/httpRequests"
import parameters from '../../../../../config/parameters';
import {loadDrive} from "../../../../../widget/api/GoogleDriveApi"
import { FormattedMessage } from 'react-intl';

import './main.scss';

class Main extends React.Component {

    constructor(props) {
        super(props);
        this.onDisconnect = this.onDisconnect.bind(this);
        this.renderText = this.renderText.bind(this);
        this.onClick = this.onClick.bind(this);
        this.setUserName = this.setUserName.bind(this);
    }
    onClick()
    {
        window.open('https://accounts.google.com/signup/v2/webcreateaccount?service=wise&continue=http%3A%2F%2Fdrive.google.com%2F%3Futm_source%3Den_US&ltmpl=drive&flowName=GlifWebSignIn&flowEntry=SignUp') 
    }
    onDisconnect = () => {
        const compId = Wix.Utils.getOrigCompId();
        const dataFile = { key: 'id', value: { id: parameters['DEFAULT_FILE'], src: parameters['DEFAULT_FILE_SRC'],  compId: compId } };
        Wix.Settings.triggerSettingsUpdatedEvent(dataFile, compId);
        const datapublicObj = {
            "compId": compId,
            "access_token": null,
            "token": null,
            "scope":null,
            "signedAt": null,
            "activeFileId": parameters['DEFAULT_FILE'],
            "isSignleFile": true,
            "userName": null,
            "disconnect": true
        };
        clearIntervalGetToken();
        this.props.setDataPublic(datapublicObj);        
        this.props.updateConnected(false);
        axios.post("api/deleteAccessToken" + httpRequest.getUrlQuery())
        .then(res => {
            this.props.connectBI("Main", "disconnect account")
        }).catch(err => {console.log(err)});
    }

    setUserName(){
        let userInfo = window.gapi.client.drive.about.get("me")
        let _this = this;
        userInfo.execute(function (resp) {
            if( (typeof _this.props.dataPublic !== 'undefined') && !_this.props.dataPublic.userName && typeof resp.name !== 'undefined') {
                _this.props.setDataPublic(..._this.props.dataPublic, {userName: resp.name}); 
                if (resp.name)       
                axios.post("api/setUserNameMigration" + httpRequest.getUrlQuery() + "&userName=" + resp.name ).then(res => {
                    console.log('setUserNameMigration',{res})
                })
            }
        });
    }

    renderText(text) {
        
        return (
            <div className='Display-Google-Drive'>
                {text}
            </div>
        )
    }

    render() {
        if(typeof this.props.dataPublic !== 'undefined' && this.props.dataPublic.userName == ''){
            loadDrive(this.setUserName);
        }
        const isErrorConnectStatus = this.props.showError || (this.props.dataPublic && this.props.dataPublic.scope && (!this.props.dataPublic.scope.includes('https://www.googleapis.com/auth/drive'))) ;   
        let _this = this;        
           return (
            <div className="main-tab">
                <img className='icon-google' src={googledrive_logo} alt='logo google drive' />
                { (typeof this.props.dataPublic !== 'undefined') ?
                !isErrorConnectStatus &&
                 (this.props.showBtn || (this.props.dataPublic && typeof this.props.dataPublic.userName !== 'undefined' && this.props.dataPublic.token !== null && window.localStorage.getItem('token') != null && window.localStorage.getItem('token') != "" ) )?
                        <div>
                            {this.renderText(<FormattedMessage id="settings.main.selectInfo"/>)}
                            {
                                this.props.dataPublic && this.props.dataPublic.activeFileId ?
                                    <UI.button
                                        label={<FormattedMessage id="settings.main.button.replace"/>}
                                        className="btn-confirm-secondary"
                                        onClick={() => onOpenModalPicker(_this)}>
                                    </UI.button>
                                    :
                                    <UI.button
                                        label={<FormattedMessage id="settings.main.button.select"/>}
                                        className="btn-confirm-primary"
                                        onClick={() => onOpenModalPicker(_this)}>
                                    </UI.button>
                            }
                            <hr className="divider-short" />
                            <div  className="connect-details" >
                            
                            {this.renderText(<FormattedMessage id="settings.main.connectAs"/>)}
                            <div className='user-name'>{ this.props.dataPublic  && this.props.dataPublic.userName ? this.props.dataPublic.userName : ''}</div>
                            <UI.button
                                label={<FormattedMessage id="settings.disconnect"/>}
                                className="btn-upgrade-link"
                                onClick={this.onDisconnect}>
                            </UI.button>
                            </div >
                        </div>
                        :
                        isErrorConnectStatus  ? 
                        <div className="my-picker">
                           {this.renderText(<FormattedMessage id="settings.main.selectInfo"/>)}
                            <Picker
                                connect={true}
                                children={
                                    <div className='notification-banner'>
                                        <div>{this.renderText(<FormattedMessage id="settings.main.notificationBannerConnect"/>)}</div>
                                    <UI.button
                                       label={<FormattedMessage id="settings.main.continue"/>}
                                        className="continue-button"
                                        onClick={()=>this.props.connectBI("Main","connect account")}>
                                    </UI.button></div>
                                }
                            />
                        </div> 
                        :
                        <div className="my-picker">
                        {this.renderText(<FormattedMessage id="settings.main.connectInfo"/>)}
                         <Picker
                             connect={true}
                             children={
                                 <UI.button
                                     label={<FormattedMessage id="settings.connectAccount"/>}
                                     className="btn-confirm-primary"
                                     onClick={()=>this.props.connectBI("Main","connect account")}>
                                 </UI.button>
                             }
                         />
                         <div className='create-new-account'>
                             <div><FormattedMessage id="settings.or"/></div>
                             <UI.button
                                 label={<FormattedMessage id="settings.link.createNewAccount"/>}
                                 className="btn-upgrade-link"
                                 onClick={this.onClick}
                                > 
                             </UI.button>
                         </div>
                     </div>

                : null }
            </div>
        )}
}
const mapDispatchToProps = dispatch => ({
    updateConnected: (showBtn) => dispatch(updateConnect(showBtn)),
    setDataPublic: (dataPublic) => dispatch(setDataPublic(dataPublic))
})

const mapStateToProps = state => ({
    dataPublic: state.dataPublicReducer.dataPublic,
    showBtn: state.userConnectReducer.showBtn,
    showError: state.userConnectReducer.showError,
    userName: state.userConnectReducer.userName,

});

export default connect(mapStateToProps, mapDispatchToProps)(Main);





// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/modules/main/main.js